import './navbar.scss';
import _ from 'lodash'
import { faTimes, faUser } from '@fortawesome/free-solid-svg-icons';
import { AuthService, User, userSelectors } from '@skinsoft/auth';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Touchable } from '@skinsoft/ui';
import * as emojiFlags from 'emoji-flags'

import { Component, Watch } from 'vue-property-decorator';
import { fetch, Proxy } from '@skinsoft/network';
import { switchMap} from 'rxjs/operators';
import { WorkspaceDataStore, workspaceSelectors } from '@skinsoft/entity';
import { ContextMenuModal } from './context-menu-modal';
export const DEFAULT_PROXY = new Proxy();
@Component({
    components: {
        sContextMenuModal: ContextMenuModal,
        sTouchable: Touchable,
    },
    props: ['title'],
    template: require('./navbar.html'),
})
export class Navbar extends ReactiveVue {
    public $authService: AuthService;
    public title: string;

    public $refs: {
        modal: ContextMenuModal;
        navbar: HTMLElement;
    };

    public user: User | null = null;
    public userIcon = faUser;
    public logOutIcon = faTimes;
    public userSelectors = userSelectors;
    private localeFlag: string | null = null;

    private $workspaceDataStore: WorkspaceDataStore;
   
    public workspaceUserInfo: any = {
        selectedWorkspace: {},
        workspaceList: []
    };
    public onlineMode = true;
    protected proxy = DEFAULT_PROXY;
    public created() {
        this.subscribeTo(this.$authService.waitForUser$(), this.onUser);
        this.checkOnLine();
    }

    public logOut() {
        if (!confirm(this.$t('navbar.logout') as string)) {
            return;
        }

        return this.$authService.logOut();
    }

    public onWorkspaceChange() {
        fetch.api(`/institution/byWorkspaces?workspaces=${[this.workspaceUserInfo.selectedWorkspace]}`, { method: 'GET'}).pipe(
            switchMap(
                institution => {
                    localStorage.setItem('institution', _.get(institution, '_embedded.institution[0].id'));
                    return fetch.api(`/users/token?institutionId=${_.get(institution, '_embedded.institution[0].id')}&workspaceId=${this.workspaceUserInfo.selectedWorkspace}`,
                        {
                            method: 'GET',
                        })
                }
            )
        ).subscribe(
            (response: any) => {
                localStorage.setItem('token', response.token);
                fetch.registerToken(response.token);
                localStorage.setItem('workspace', this.workspaceUserInfo.selectedWorkspace);
                this.emitOnBus('change_current_workspace', this.workspaceUserInfo.selectedWorkspace);
            })
    }

    public getWorkspaceName(workspace) {
        return  workspaceSelectors.name(workspace, this.$i18n.locale);
    }
    
    public onTouchTimed = () => {
        this.$refs.modal.open();
    };

    private onUser(user: User | null) {
        this.user = user;
        if (user) {
            if(localStorage.getItem('workspace')){
                this.workspaceUserInfo.selectedWorkspace = localStorage.getItem('workspace');
            }else{
                this.workspaceUserInfo.selectedWorkspace = userSelectors.defaultWorkspace(user).id;
            }
            this.workspaceUserInfo.workspaceList = userSelectors.userWorkspaces(user);
        }
    }

    get currentWorkspaceInfo(){
        return this.workspaceUserInfo.workspaceList.filter(workspace => workspace.id === this.workspaceUserInfo.selectedWorkspace)[0];
    }

    @Watch('$i18n.locale', { immediate: true })
    private onLocaleChange() {
        // If the locale name doesn't correspond to the country code, specify it in the locale file (ex : fr-ca => ca)
        const countryCode = this.$t('countryCode');
        const localeId = countryCode !== 'countryCode' ? countryCode : this.$i18n.locale;
        const code = emojiFlags.countryCode(localeId);
        this.localeFlag = code ? code.emoji : null;
    }

    private checkOnLine() {
        this.onlineMode = window.navigator.onLine;
        requestAnimationFrame(this.checkOnLine);
    }
}
